import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { IComponentModal } from "../../../../../../Components/Modais/IModalComponent";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { BuscarFormularioPeloNomeController } from "../../../../../../Controllers/Geral/Formularios/FormulariosControllers";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import { IAtendimentoExtraDetalhado } from "../../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import VisualizarFormulario from "../../../../../Geral/Formularios/VisualizarFormulario";
import { IAcoesAcessoUsuario } from "../../../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";
interface IBotaoResponderPesquisaDeSatisfacao {
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    className?: string;
    tpPesquisa?: "AssistenciaTec" | "Vistoria";
    titulo?: string;
    AcaoAcessoUsuario?: IAcoesAcessoUsuario[] | undefined;
}

export default function BotaoResponderPesquisaDeSatisfacao(
    props: IBotaoResponderPesquisaDeSatisfacao
) {
    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoExtraDetalhado;

    const { value: BuscarFormularioPeloNome } = useAsyncEffect(async () => {
        if (props.tpPesquisa) {
            return BuscarFormularioPeloNomeController(
                Atendimento?.CD_ETAPA,
                props.tpPesquisa
            );
        }
    }, []);

    return (
        <button
            type="button"
            className={
                props.className ? props.className : "btn btn-sm btn-primary m-1"
            }
            onClick={() => {
                if (BuscarFormularioPeloNome) {
                    props.setShow(true);
                    props.setModal({
                        headerComponent: props.titulo
                            ? props.titulo
                            : "Responder Pesquisa de Satisfação",
                        IconHeader: faClipboard,
                        Component: () => (
                            <VisualizarFormulario
                                setShow={props.setShow}
                                idFormulario={
                                    BuscarFormularioPeloNome.ID_FORMULARIO
                                }
                                respondendoFormulario={true}
                            />
                        ),
                        size: "lg",
                    });
                }
            }}
            disabled={
                // !props.AcaoAcessoUsuario?.find(
                //     (acaoFiltrada) => acaoFiltrada.ID_ACAO === 20
                // )?.FL_USUARIO_ACESSA ||
                Atendimento.FL_SINCRONIZADO === false
            }
        >
            <FontAwesomeIcon icon={faClipboard} className="mr-2" />
            {props.titulo ? props.titulo : "Responder Pesquisa de Satisfação"}
        </button>
    );
}
